module.exports = __webpack_public_path__ + "assets/img/img-map-miyazaki.8b391d7a.svg";